import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabsComponentComponent } from './tabs-component.component';
import { SharedModule } from 'app/shared/shared.module';



@NgModule({
  declarations: [
    TabsComponentComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [
    TabsComponentComponent
  ]
})
export class TabsComponentModule { }
